export const toolsRoutes = {
  tools: () => '/tools',
  tool: (toolId: string) => `/tools/${toolId}`,
  enableOrDisableTool: (toolId: string, switcher: 'enable' | 'disable') =>
    `/tools/${toolId}/${switcher}`,
  artifacts: () => '/tools/artifacts',
  publishOrUnpublishArtifact: (artifactId: string, switcher: 'publish' | 'unpublish') =>
    `/tools/artifacts/${artifactId}/${switcher}`,
  styles: () => '/tools/styles',
  style: (styleId: string) => `/tools/styles/${styleId}`,
  restoreStyle: (styleId: string) => `/tools/styles/${styleId}/restore`,
  stylePrompts: (styleId: string) => `/tools/styles/${styleId}/prompts`,
  stylePrompt: (promptId: string) => `/tools/styles/prompts/${promptId}`,
  publishStylePrompt: (promptId: string) => `/tools/styles/prompts/${promptId}/publish`,
  models: () => '/tools/models',
  modelCatalogue: () => '/tools/models/catalogue',
  model: (modelId: string) => `/tools/models/${modelId}`,
  restoreModel: (modelId: string) => `/tools/models/${modelId}/restore`,
  modelPrices: (modelId: string) => `/tools/models/${modelId}/prices`,
  toolPrices: (toolId: string) => `/tools/${toolId}/prices`,
  modelPriceByTool: (toolId: string, modelId: string) =>
    `/tools/${toolId}/models/${modelId}/prices`,
};
